import script from "./ProxyContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProxyContent.vue?vue&type=script&setup=true&lang=js"

import "./ProxyContent.vue?vue&type=style&index=0&id=e5133a32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5133a32"]])

export default __exports__